import React, { useEffect, useState } from 'react';
import { getListSubmissionsByBounty } from '../../../../../redux/actions/daoUI/submissionBounties.action';

const SubmissionsTab = ({ bounty, bountyId, activeTab }) => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (activeTab === 'SUBMISSIONS') {
      const fetchSubmissions = async () => {
        setLoading(true);
        setError(null);
        try {
          const params = { bountyId };
          const response = await getListSubmissionsByBounty(params)();
          if (response) {
            setSubmissions(response.data || []);
          } else {
            setSubmissions([]);
          }
        } catch (err) {
          console.error('Error fetching submissions:', err);
          setError('Failed to load submissions');
          setSubmissions([]);
        } finally {
          setLoading(false);
        }
      };
      
      if (bountyId) fetchSubmissions();
    }
  }, [activeTab, bountyId]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', justifyContent: 'space-between' }}>
        <h3 style={{ color: '#03edc3' }}>Submissions ({bounty?.name || 'Bounty test 1309 1'})</h3>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: '#fff', color: '#181c22', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #0006' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={{ padding: '14px', textAlign: 'left' }}>Team</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Email Team Lead</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Challenge</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Result Link</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Result Presentation</th>
              <th style={{ padding: '14px', textAlign: 'left' }}>Result Demo</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: '#888', padding: 24 }}>Loading...</td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: '#d32f2f', padding: 24 }}>{error}</td>
              </tr>
            ) : Array.isArray(submissions) && submissions.length > 0 ? (
              submissions.map((submission) => (
                <tr key={submission._id || submission.id || Math.random().toString()} style={{ cursor: 'pointer' }}>
                  <td style={{ padding: '12px' }}>{submission.team}</td>
                  <td style={{ padding: '12px' }}>{submission.emailTeamLead}</td>
                  <td style={{ padding: '12px' }}>{submission.challenge}</td>
                  <td style={{ padding: '12px' }}>{submission.resultLink}</td>
                  <td style={{ padding: '12px' }}>{submission.resultPresentation}</td>
                  <td style={{ padding: '12px' }}>{submission.resultDemo}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', color: '#888', padding: 24 }}>No data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubmissionsTab; 